// extracted by mini-css-extract-plugin
export var container = "_be-0";
export var icon = "_be-1";
export var text = "_be-2";